import { render, staticRenderFns } from "./MultiSelectWithIconsBaseDropdown.vue?vue&type=template&id=457bbcb5&"
import script from "./MultiSelectWithIconsBaseDropdown.vue?vue&type=script&lang=js&"
export * from "./MultiSelectWithIconsBaseDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectWithIconsBaseDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports